interface PropertyInputProps {
  label: string;
  value: number | string;
  onChange: (value: number | string) => void;
  type?: 'number' | 'text';
  min?: number;
  max?: number;
  step?: number;
  disabled?: boolean;
}

export function PropertyInput({
  label,
  value,
  onChange,
  type = 'number',
  min,
  max,
  step = 1,
  disabled = false,
}: PropertyInputProps) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (type === 'number') {
      const numValue = parseFloat(e.target.value);
      if (!isNaN(numValue)) {
        onChange(numValue);
      }
    } else {
      onChange(e.target.value);
    }
  };

  return (
    <div className="property-input-group">
      <label className="property-input-label">{label}</label>
      <input
        type={type}
        className="property-input"
        value={value}
        onChange={handleChange}
        min={min}
        max={max}
        step={step}
        disabled={disabled}
      />
    </div>
  );
}
